import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { TutorialsCategories } from '../../utils/constant';

const TutorialLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="h-full overflow-auto homepage-scrollbar w-full text-white p-4">
      <div className="h-auto flex gap-6 mx-0 md:mx-5 my-4">
        <div className="min-w-[200px] min-h-full  h-fit hidden lg:block bg-[#1e1f22] p-4 rounded-[10px] relative top-[60px] shadow-lg">
          <div className="w-full flex flex-col gap-6 ">
            {TutorialsCategories.map((v, i) => (
              <React.Fragment key={i}>
                <div>{v?.type}</div>
                {v?.submenu.map((val, ind) => (
                  <div
                    key={ind}
                    className={`py-1 px-3 w-full text-[#D9D9D9] text-left  text-opacity-80 cursor-pointer text-sm rounded-[50px] flex items-center justify-start transition-all duration-300 ${
                      pathname === `${val?.path}/${val?.category}`
                        ? 'bg-[#31333A] text-white font-medium shadow-md'
                        : 'hover:bg-[#31333A]'
                    }`}
                    onClick={() => navigate(`${val?.path}/${val?.category}`)}
                  >
                    {val?.name}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default TutorialLayout;
